import { FunctionComponent } from 'react'
import clsx from 'clsx'
import { WidgetProps } from '@rjsf/core'
import { Autocomplete } from '@dxp-module/common'
import myAccountGenericInputStyles from '../myAccountGenericInput.styles'
import autoCompleteStyles from './autocomplete.styles'

const AutocompleteInput: FunctionComponent<WidgetProps> = props => {
  const styles = autoCompleteStyles()
  const genericInputStyles = myAccountGenericInputStyles()

  const classes = {
    root: clsx([genericInputStyles.root, styles.root]),
    fieldWrapper: genericInputStyles.fieldWrapper,
    input: genericInputStyles.input,
    errorText: genericInputStyles.errorText,
    notchedOutline: genericInputStyles.notchedOutline,
    focused: genericInputStyles.focused,
    inputError: genericInputStyles.inputError,
    helperTextError: genericInputStyles.helperTextError,
    dateCalendar: genericInputStyles.dateCalendar,
    label: genericInputStyles.label,
    phonePrefix: genericInputStyles.phonePrefix,
    noOptions: genericInputStyles.noOptions,
    inputNoLabel: genericInputStyles.inputNoLabel,
    labelContainer: genericInputStyles.labelContainer,
    labelAsterisk: genericInputStyles.labelAsterisk,
  }

  return <Autocomplete classes={classes} {...props} />
}

export default AutocompleteInput
